import {LoginById} from './LoginById';

export const getLoginById = () => LoginById;
